export default "__VITE_ASSET__e38ec11a__"